import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #432726;
  text-align: center;
  margin-block-start: 2rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const StyledActionButtonLink = styled(ActionButton)`
  margin-block-start: 1.5rem;
`;

export const HeaderText = styled.h5`
  margin: 0;
  font-size: 1.5rem;
  margin-block-start: 1.25rem;
  font-weight: ${Styles.fontWeight.black};
`;

export const SubText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  margin-block-start: 0.25rem;
`;

export const ImageWrapper = styled.div`
  width: 9.5rem;
  height: 9.5rem;
`;
